import { Button, Dropdown, Flex } from "antd";
import { ColumnType } from "antd/es/table";
import { BID_STATUSES, BidRequestStatus, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { DOC_HINTS_TYPE_ENUM, HintsType } from "interfaces/tooltipSettings";
import { CustomButton, Status } from "ui";
import { dateFormat, parseErrorMessage } from "utils";
import { AddTemplatesFileBtn } from "../DocumentTemplates/TemplatesBlock/AddTemplatesFileBtn";
import styles from "./hintsManagement.module.css";

import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";
import { ColumnBtnBlock } from "./ColumnBtnBlock";

export const getColumns = () => {
  return [
    {
      dataIndex: "status",
      key: "status",
      width: "300",
      title: "Статус",
      render: (_: any, record: HintsType) => {
        return (
          <Flex justify="start">
            <Status
              color={BID_STATUSES.colors[record.objectStatus as BidRequestStatus] ?? record.objectStatus}
              children={BID_STATUSES.texts[record.objectStatus as BidRequestStatus] ?? record.objectStatus}
            />
          </Flex>
        );
      },
    },
    {
      dataIndex: "updated",
      key: "updated",
      width: "300",
      title: "Обновлено",
      render: (_: any, record: HintsType) => {
        return dateFormat(record.updatedAt, true);
      },
    },

    {
      dataIndex: "status",
      key: "status",
      width: "200",
      render: (_: any, record: HintsType) => {
        return <ColumnBtnBlock status={record.objectStatus} />;
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<HintsType>>;
};
